var exports = {
  "lD": "ThreadSidePanel.module__split___WVlPRm",
  "QA": "ThreadSidePanel.module__splitMain___WVlPRm",
  "nd": "ThreadSidePanel.module__panel___WVlPRm",
  "Di": "ThreadSidePanel.module__resizeHandle___WVlPRm",
  "wx": "ThreadSidePanel.module__header___WVlPRm",
  "nr": "ThreadSidePanel.module__headerIcon___WVlPRm",
  "qd": "ThreadSidePanel.module__headerTitle___WVlPRm",
  "$s": "ThreadSidePanel.module__headerActions___WVlPRm",
  "Qs": "ThreadSidePanel.module__content___WVlPRm",
  "rp": "ThreadSidePanel.module__membersPopout___WVlPRm",
};

module.exports = exports;
